export class ProgramsAndServicesFilter {
	entryDateStart: Date = undefined;
	entryDateEnd: Date = undefined;
	exitDateStart: Date = undefined;
	exitDateEnd: Date = undefined;
	programName = '';
	serviceName = '';
	shown = 0;
	onThisDate: Date = undefined;
}
